import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import cookie from 'react-cookies';
import { useUnsavedChanges } from '../Root/UnsavedChangesContext';


class Menu extends Component {

    constructor(props){
        super(props);
        
        this.state = {
            loading: false,
            security: cookie.load('user'),
            roles: [],
            menu: this.props.menus
        } 
    }

    getUrlAgrupador = (agrupador = "") => {
        switch(agrupador) {
            case "Administradores":
                return "/administradores";
            case "Usuarios":
                return "/permisos"
            case "Reportes":
                return "/reportes"
            case "Configuradores":
                return "/configuradores"
            case "Boletín de Inteligencia":
                return "/boletin"
            case "Recursos":
                return "/recurso"
            case "Eventos":
                return "/eventos"
            case "Productos":
                return "/ficha-producto"
            case "Paises":
                return "/ficha-pais"
            // default:
            //   return "/boletin";
        }
    } 

    // Mismo patrón que Header.js/handleLogoClick: intercepta la navegación de las opciones
    // del menú lateral si hay cambios sin guardar en el formulario activo (add/edit-recurso),
    // mostrando el modal de confirmación en vez de navegar directo.
    handleMenuClick = (e, sUrl) => {
        e.preventDefault();
        const { requestNavigation, history } = this.props;
        const goTo = () => history.push(sUrl);
        if (requestNavigation) {
            requestNavigation(goTo);
        } else {
            goTo();
        }
    }
	  
    render() {
      return (
        this.state.security.cRolesxUsuario != null ?

          <div className="divContenidoPanelNav">
              <div className="divClosePanelNav" />
              <div className="divSearchNav">
                <input 
                  type="text" 
                  placeholder="Buscar..." 
                  id="txtBuscarMenu" 
                />
                <input 
                  type="submit" 
                  defaultValue="Buscar" 
                />
              </div>

              <div className="scrollgeneral divHeightMenu">
                  {this.state.menu.map((resource) => (
                        <React.Fragment key={resource.sAgrupador}>
                          <div className="lblTituloNav">
                            {resource.sAgrupador}
                          </div>	
                          <div className="divItemNav">
                            { 
                              resource.sMenu.length > 1 &&
                              resource.sMenu.map((option, index) => {
                                let url = this.getUrlAgrupador(resource.sAgrupador);

                                if(option.sUrl !== url){
                                  return (
                                    <a key={index} href={option.sUrl} onClick={(e) => this.handleMenuClick(e, option.sUrl)} className="linkMenu">
                                        {option.sOpcNombre}
                                    </a>
                                  )
                                }
                              })
                            }

                            { 
                              resource.sMenu.length == 1 &&
                              resource.sMenu.map((option, index) => {
                                
                                  return (
                                    <a key={index} href={option.sUrl} onClick={(e) => this.handleMenuClick(e, option.sUrl)} className="linkMenu">
                                        {option.sOpcNombre}
                                    </a>
                                  )
                                
                              })
                            }
                          </div>
                        </React.Fragment>
                    ))
                  }
              </div>
          </div>

        :

          <div>
            <ul className="navbar-nav sidebar sidebar-dark accordion" id="accordionSidebar">
                <a className="sidebar-brand d-flex align-items-center justify-content-center">
                <div className="sidebar-brand-icon">
                    <img src="../images/logo.png" alt="" />
                </div>
                </a>
                <li  className="sidebar__option">
                    <div> <b> No tiene Roles asignados </b></div>
                </li>
            </ul>
          </div>

    )}
}

// Wrapper funcional: permite usar el hook useUnsavedChanges y pasarlo como prop
// al menú (que sigue siendo un componente de clase, sin tocar su lógica interna).
// withRouter agrega `history` como prop, ya que Menu no se monta dentro de una <Route>
// de React Router (se monta directamente en Root/root.js).
const MenuWithGuard = (props) => {
    const { requestNavigation } = useUnsavedChanges();
    return <Menu {...props} requestNavigation={requestNavigation} />;
};

export default withRouter(MenuWithGuard);
 

